/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.ThreadViewRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const AuditParamsDiscriminantKey = '@type';
export const BotHandoffTypename = 'com.hubspot.cv.common.audit.core.params.BotHandoff';
export const BotHandoffDiscriminant = 'BOT_HANDOFF';
export const BotHandoffDiscriminantKey = '@type';
export const CrmSourceTypename = 'com.hubspot.cv.common.audit.core.params.CrmSource';
export const CrmSourceDiscriminant = 'CRM_SOURCE';
export const CrmSourceDiscriminantKey = '@type';
export const IntegratorAuditTypename = 'com.hubspot.cv.common.audit.core.params.IntegratorAudit';
export const IntegratorAuditDiscriminant = 'INTEGRATOR';
export const IntegratorAuditDiscriminantKey = '@type';
export const ManualTypename = 'com.hubspot.cv.common.audit.core.params.Manual';
export const ManualDiscriminant = 'MANUAL';
export const ManualDiscriminantKey = '@type';
export const MultipleAuditsTypename = 'com.hubspot.cv.common.audit.core.params.MultipleAudits';
export const MultipleAuditsDiscriminant = 'MULTIPLE';
export const MultipleAuditsDiscriminantKey = '@type';
export const SystemAutomaticTypename = 'com.hubspot.cv.common.audit.core.params.SystemAutomatic';
export const SystemAutomaticDiscriminant = 'SYSTEM_AUTOMATIC';
export const SystemAutomaticDiscriminantKey = '@type';
export const SystemMigrationTypename = 'com.hubspot.cv.common.audit.core.params.SystemMigration';
export const SystemMigrationDiscriminant = 'SYSTEM_MIGRATION';
export const SystemMigrationDiscriminantKey = '@type';
export const SystemTestTypename = 'com.hubspot.cv.common.audit.core.params.SystemTest';
export const SystemTestDiscriminant = 'SYSTEM_TEST';
export const SystemTestDiscriminantKey = '@type';
export const UnknownTypename = 'com.hubspot.cv.common.audit.core.params.Unknown';
export const UnknownDiscriminant = 'UNKNOWN';
export const UnknownDiscriminantKey = '@type';
export const VisitorAuditTypename = 'com.hubspot.cv.common.audit.core.params.VisitorAudit';
export const VisitorAuditDiscriminant = 'VISITOR';
export const VisitorAuditDiscriminantKey = '@type';
export const AssignmentUpdateMessageTypename = 'com.hubspot.cv.pubsub.core.message.AssignmentUpdateMessage';
export const AssignmentUpdateMessageDiscriminant = 'ASSIGNMENT_UPDATE';
export const AssignmentUpdateMessageDiscriminantKey = '@type';
export const AvailabilityAutoReplyMessageTypename = 'com.hubspot.cv.pubsub.core.message.AvailabilityAutoReplyMessage';
export const AvailabilityAutoReplyMessageDiscriminant = 'AVAILABILITY_AUTO_REPLY';
export const AvailabilityAutoReplyMessageDiscriminantKey = '@type';
export const BatchSmsGeneratedUserMessageTypename = 'com.hubspot.cv.pubsub.core.message.BatchSmsGeneratedUserMessage';
export const BatchSmsGeneratedUserMessageDiscriminant = 'BATCH_SMS_GENERATED_USER_MESSAGE';
export const BatchSmsGeneratedUserMessageDiscriminantKey = '@type';
export const BlockFilteredChangeInfoTypename = 'com.hubspot.cv.pubsub.core.message.BlockFilteredChangeInfo';
export const BlockFilteredChangeInfoDiscriminant = 'BLOCK';
export const BlockFilteredChangeInfoDiscriminantKey = '@type';
export const ChatTranscriptSentMessageTypename = 'com.hubspot.cv.pubsub.core.message.ChatTranscriptSentMessage';
export const ChatTranscriptSentMessageDiscriminant = 'CHAT_TRANSCRIPT_SENT';
export const ChatTranscriptSentMessageDiscriminantKey = '@type';
export const ChatTranscriptSentVisitorNotificationMessageTypename = 'com.hubspot.cv.pubsub.core.message.ChatTranscriptSentVisitorNotificationMessage';
export const ChatTranscriptSentVisitorNotificationMessageDiscriminant = 'CHAT_TRANSCRIPT_SENT_VISITOR_NOTIFICATION';
export const ChatTranscriptSentVisitorNotificationMessageDiscriminantKey = '@type';
export const ChatflowContextTypename = 'com.hubspot.cv.pubsub.core.message.ChatflowContext';
export const ChatflowContextDiscriminant = 'CHATFLOW';
export const ChatflowContextDiscriminantKey = '@type';
export const ConnectedAccountContextTypename = 'com.hubspot.cv.pubsub.core.message.ConnectedAccountContext';
export const ConnectedAccountContextDiscriminant = 'CONNECTED_ACCOUNT';
export const ConnectedAccountContextDiscriminantKey = '@type';
export const ConnectedCrmObjectContextTypename = 'com.hubspot.cv.pubsub.core.message.ConnectedCrmObjectContext';
export const ConnectedCrmObjectContextDiscriminant = 'CONNECTED_CRM_OBJECT';
export const ConnectedCrmObjectContextDiscriminantKey = '@type';
export const ContactAssociationMessageTypename = 'com.hubspot.cv.pubsub.core.message.ContactAssociationMessage';
export const ContactAssociationMessageDiscriminant = 'CONTACT_ASSOCIATION';
export const ContactAssociationMessageDiscriminantKey = '@type';
export const ContextDiscriminantKey = '@type';
export const ContextUpdateMessageTypename = 'com.hubspot.cv.pubsub.core.message.ContextUpdateMessage';
export const ContextUpdateMessageDiscriminant = 'CONTEXT_UPDATE';
export const ContextUpdateMessageDiscriminantKey = '@type';
export const ConversationMessageDiscriminantKey = '@type';
export const CrmObjectContextTypename = 'com.hubspot.cv.pubsub.core.message.CrmObjectContext';
export const CrmObjectContextDiscriminant = 'CRM_OBJECT';
export const CrmObjectContextDiscriminantKey = '@type';
export const CrmObjectWorkflowEmailSentTypename = 'com.hubspot.cv.pubsub.core.message.CrmObjectWorkflowEmailSent';
export const CrmObjectWorkflowEmailSentDiscriminant = 'CRM_OBJECT_WORKFLOW_EMAIL_SENT';
export const CrmObjectWorkflowEmailSentDiscriminantKey = '@type';
export const CustomTypename = 'com.hubspot.cv.pubsub.core.message.Custom';
export const CustomDiscriminant = 'CUSTOM';
export const CustomDiscriminantKey = '@type';
export const CustomerAgentActionExecutionMessageTypename = 'com.hubspot.cv.pubsub.core.message.CustomerAgentActionExecutionMessage';
export const CustomerAgentActionExecutionMessageDiscriminant = 'CUSTOMER_AGENT_ACTION_EXECUTION_MESSAGE';
export const CustomerAgentActionExecutionMessageDiscriminantKey = '@type';
export const CustomerAgentAutomatedMessageTypename = 'com.hubspot.cv.pubsub.core.message.CustomerAgentAutomatedMessage';
export const CustomerAgentAutomatedMessageDiscriminant = 'CUSTOMER_AGENT_AUTOMATED_MESSAGE';
export const CustomerAgentAutomatedMessageDiscriminantKey = '@type';
export const CustomerAgentEventTypename = 'com.hubspot.cv.pubsub.core.message.CustomerAgentEvent';
export const CustomerAgentEventDiscriminant = 'CUSTOMER_AGENT_EVENT';
export const CustomerAgentEventDiscriminantKey = '@type';
export const CustomerAgentFeedbackMessageTypename = 'com.hubspot.cv.pubsub.core.message.CustomerAgentFeedbackMessage';
export const CustomerAgentFeedbackMessageDiscriminant = 'CUSTOMER_AGENT_FEEDBACK';
export const CustomerAgentFeedbackMessageDiscriminantKey = '@type';
export const CustomerAgentMaintenanceModeMessageTypename = 'com.hubspot.cv.pubsub.core.message.CustomerAgentMaintenanceModeMessage';
export const CustomerAgentMaintenanceModeMessageDiscriminant = 'CUSTOMER_AGENT_MAINTENANCE_MODE_MESSAGE';
export const CustomerAgentMaintenanceModeMessageDiscriminantKey = '@type';
export const EmailCapturePromptMessageTypename = 'com.hubspot.cv.pubsub.core.message.EmailCapturePromptMessage';
export const EmailCapturePromptMessageDiscriminant = 'EMAIL_CAPTURE_PROMPT';
export const EmailCapturePromptMessageDiscriminantKey = '@type';
export const EmailCaptureResponseMessageTypename = 'com.hubspot.cv.pubsub.core.message.EmailCaptureResponseMessage';
export const EmailCaptureResponseMessageDiscriminant = 'EMAIL_CAPTURE_RESPONSE';
export const EmailCaptureResponseMessageDiscriminantKey = '@type';
export const EmailIdentificationResultMessageTypename = 'com.hubspot.cv.pubsub.core.message.EmailIdentificationResultMessage';
export const EmailIdentificationResultMessageDiscriminant = 'EMAIL_IDENTIFICATION_RESULT_MESSAGE';
export const EmailIdentificationResultMessageDiscriminantKey = '@type';
export const EntryUrlTypename = 'com.hubspot.cv.pubsub.core.message.EntryUrl';
export const EntryUrlDiscriminant = 'ENTRY_URL';
export const EntryUrlDiscriminantKey = '@type';

/**
 * Virtual record for map with known enum keys
 */

export const FeedbackSubmissionMessageTypename = 'com.hubspot.cv.pubsub.core.message.FeedbackSubmissionMessage';
export const FeedbackSubmissionMessageDiscriminant = 'FEEDBACK_SUBMISSION';
export const FeedbackSubmissionMessageDiscriminantKey = '@type';
export const FeedbackSurveyMessageTypename = 'com.hubspot.cv.pubsub.core.message.FeedbackSurveyMessage';
export const FeedbackSurveyMessageDiscriminant = 'FEEDBACK_SURVEY';
export const FeedbackSurveyMessageDiscriminantKey = '@type';
export const FilteredChangeInfoDiscriminantKey = '@type';
export const FilteredChangeMessageTypename = 'com.hubspot.cv.pubsub.core.message.FilteredChangeMessage';
export const FilteredChangeMessageDiscriminant = 'FILTERED_CHANGE';
export const FilteredChangeMessageDiscriminantKey = '@type';
export const ForwardedEmailUpdateContextTypename = 'com.hubspot.cv.pubsub.core.message.ForwardedEmailUpdateContext';
export const ForwardedEmailUpdateContextDiscriminant = 'FORWARDED_EMAIL_UPDATE';
export const ForwardedEmailUpdateContextDiscriminantKey = '@type';
export const HelpDeskCommentReplyMessageTypename = 'com.hubspot.cv.pubsub.core.message.HelpDeskCommentReplyMessage';
export const HelpDeskCommentReplyMessageDiscriminant = 'HELP_DESK_COMMENT_REPLY_SYSTEM_MESSAGE';
export const HelpDeskCommentReplyMessageDiscriminantKey = '@type';
export const HelpdeskTicketSplitUpdateMessageTypename = 'com.hubspot.cv.pubsub.core.message.HelpdeskTicketSplitUpdateMessage';
export const HelpdeskTicketSplitUpdateMessageDiscriminant = 'HELP_DESK_TICKET_SPLIT_UPDATE_MESSAGE';
export const HelpdeskTicketSplitUpdateMessageDiscriminantKey = '@type';
export const InteractiveCardRequestMessageTypename = 'com.hubspot.cv.pubsub.core.message.InteractiveCardRequestMessage';
export const InteractiveCardRequestMessageDiscriminant = 'INTERACTIVE_CARD_REQUEST_MESSAGE';
export const InteractiveCardRequestMessageDiscriminantKey = '@type';
export const InteractiveCardResponseMessageTypename = 'com.hubspot.cv.pubsub.core.message.InteractiveCardResponseMessage';
export const InteractiveCardResponseMessageDiscriminant = 'INTERACTIVE_CARD_RESPONSE_MESSAGE';
export const InteractiveCardResponseMessageDiscriminantKey = '@type';
export const MarketingEmailReplyContextTypename = 'com.hubspot.cv.pubsub.core.message.MarketingEmailReplyContext';
export const MarketingEmailReplyContextDiscriminant = 'MARKETING_EMAIL_REPLY';
export const MarketingEmailReplyContextDiscriminantKey = '@type';
export const NavigatorLanguagesTypename = 'com.hubspot.cv.pubsub.core.message.NavigatorLanguages';
export const NavigatorLanguagesDiscriminant = 'NAVIGATOR_LANGUAGES';
export const NavigatorLanguagesDiscriminantKey = '@type';
export const OfficeHoursMessageTypename = 'com.hubspot.cv.pubsub.core.message.OfficeHoursMessage';
export const OfficeHoursMessageDiscriminant = 'OFFICE_HOURS';
export const OfficeHoursMessageDiscriminantKey = '@type';
export const PartialMessageTypename = 'com.hubspot.cv.pubsub.core.message.PartialMessage';
export const PartialMessageDiscriminant = 'PARTIAL_MESSAGE';
export const PartialMessageDiscriminantKey = '@type';
export const ReadThreadMessageTypename = 'com.hubspot.cv.pubsub.core.message.ReadThreadMessage';
export const ReadThreadMessageDiscriminant = 'READ_THREAD';
export const ReadThreadMessageDiscriminantKey = '@type';
export const SmsConsentAutomatedMessageTypename = 'com.hubspot.cv.pubsub.core.message.SmsConsentAutomatedMessage';
export const SmsConsentAutomatedMessageDiscriminant = 'SMS_CONSENT_AUTOMATED_MESSAGE';
export const SmsConsentAutomatedMessageDiscriminantKey = '@type';
export const SpamFilteredChangeInfoTypename = 'com.hubspot.cv.pubsub.core.message.SpamFilteredChangeInfo';
export const SpamFilteredChangeInfoDiscriminant = 'SPAM';
export const SpamFilteredChangeInfoDiscriminantKey = '@type';
export const ThreadCommentTypename = 'com.hubspot.cv.pubsub.core.message.ThreadComment';
export const ThreadCommentDiscriminant = 'THREAD_COMMENT';
export const ThreadCommentDiscriminantKey = '@type';
export const ThreadInboxUpdatedMessageTypename = 'com.hubspot.cv.pubsub.core.message.ThreadInboxUpdatedMessage';
export const ThreadInboxUpdatedMessageDiscriminant = 'THREAD_INBOX_UPDATED';
export const ThreadInboxUpdatedMessageDiscriminantKey = '@type';
export const ThreadPausedOnGenericChannelMessageTypename = 'com.hubspot.cv.pubsub.core.message.ThreadPausedOnGenericChannelMessage';
export const ThreadPausedOnGenericChannelMessageDiscriminant = 'THREAD_PAUSED_ON_GENERIC_CHANNEL';
export const ThreadPausedOnGenericChannelMessageDiscriminantKey = '@type';
export const ThreadStatusUpdateMessageTypename = 'com.hubspot.cv.pubsub.core.message.ThreadStatusUpdateMessage';
export const ThreadStatusUpdateMessageDiscriminant = 'THREAD_STATUS_UPDATE';
export const ThreadStatusUpdateMessageDiscriminantKey = '@type';
export const TicketCreationFailureMessageTypename = 'com.hubspot.cv.pubsub.core.message.TicketCreationFailureMessage';
export const TicketCreationFailureMessageDiscriminant = 'TICKET_CREATION_FAILURE';
export const TicketCreationFailureMessageDiscriminantKey = '@type';
export const TypicalResponseTimeMessageTypename = 'com.hubspot.cv.pubsub.core.message.TypicalResponseTimeMessage';
export const TypicalResponseTimeMessageDiscriminant = 'TYPICAL_RESPONSE_TIME';
export const TypicalResponseTimeMessageDiscriminantKey = '@type';
export const TypingMessageTypename = 'com.hubspot.cv.pubsub.core.message.TypingMessage';
export const TypingMessageDiscriminant = 'TYPING';
export const TypingMessageDiscriminantKey = '@type';
export const WorkflowGeneratedUserMessageTypename = 'com.hubspot.cv.pubsub.core.message.WorkflowGeneratedUserMessage';
export const WorkflowGeneratedUserMessageDiscriminant = 'WORKFLOW_GENERATED_USER_MESSAGE';
export const WorkflowGeneratedUserMessageDiscriminantKey = '@type';
export const AgentSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.AgentSender';
export const AgentSenderDiscriminant = 'AGENT_SENDER';
export const AgentSenderDiscriminantKey = '@type';
export const AiInferenceMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.AiInferenceMetadata';
export const AiInferenceMetadataDiscriminant = 'AI_INFERENCE_METADATA';
export const AiInferenceMetadataDiscriminantKey = '@type';
export const BotSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.BotSender';
export const BotSenderDiscriminant = 'BOT_SENDER';
export const BotSenderDiscriminantKey = '@type';
export const CallMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.CallMetadata';
export const CallMetadataDiscriminant = 'CALL_METADATA';
export const CallMetadataDiscriminantKey = '@type';
export const CitationTypename = 'com.hubspot.cv.pubsub.core.message.common.Citation';
export const CitationDiscriminant = 'CITATION';
export const CitationDiscriminantKey = '@type';
export const CommonMessageTypename = 'com.hubspot.cv.pubsub.core.message.common.CommonMessage';
export const CommonMessageDiscriminant = 'COMMON_MESSAGE';
export const CommonMessageDiscriminantKey = '@type';
export const ContactAttachmentTypename = 'com.hubspot.cv.pubsub.core.message.common.ContactAttachment';
export const ContactAttachmentDiscriminant = 'CONTACT';
export const ContactAttachmentDiscriminantKey = '@type';
export const CustomerAgentAssignmentTypename = 'com.hubspot.cv.pubsub.core.message.common.CustomerAgentAssignment';
export const CustomerAgentAssignmentDiscriminant = 'CUSTOMER_AGENT_ASSIGNMENT';
export const CustomerAgentAssignmentDiscriminantKey = '@type';
export const EmailMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.EmailMetadata';
export const EmailMetadataDiscriminant = 'EMAIL_METADATA';
export const EmailMetadataDiscriminantKey = '@type';

/**
 * Virtual record for map with known enum keys
 */

export const FilesTypename = 'com.hubspot.cv.pubsub.core.message.common.Files';
export const FilesDiscriminant = 'FILES';
export const FilesDiscriminantKey = '@type';
export const InlineImagesTypename = 'com.hubspot.cv.pubsub.core.message.common.InlineImages';
export const InlineImagesDiscriminant = 'INLINE_IMAGES';
export const InlineImagesDiscriminantKey = '@type';
export const IntegratorSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.IntegratorSender';
export const IntegratorSenderDiscriminant = 'INTEGRATOR_SENDER';
export const IntegratorSenderDiscriminantKey = '@type';
export const InteractiveCardTypename = 'com.hubspot.cv.pubsub.core.message.common.InteractiveCard';
export const InteractiveCardDiscriminant = 'INTERACTIVE_CARD';
export const InteractiveCardDiscriminantKey = '@type';
export const LocationTypename = 'com.hubspot.cv.pubsub.core.message.common.Location';
export const LocationDiscriminant = 'LOCATION';
export const LocationDiscriminantKey = '@type';
export const MentionsTypename = 'com.hubspot.cv.pubsub.core.message.common.Mentions';
export const MentionsDiscriminant = 'MENTIONS';
export const MentionsDiscriminantKey = '@type';
export const MessageFeedbackRequestTypename = 'com.hubspot.cv.pubsub.core.message.common.MessageFeedbackRequest';
export const MessageFeedbackRequestDiscriminant = 'MESSAGE_FEEDBACK_REQUEST';
export const MessageFeedbackRequestDiscriminantKey = '@type';
export const MessageHeaderTypename = 'com.hubspot.cv.pubsub.core.message.common.MessageHeader';
export const MessageHeaderDiscriminant = 'MESSAGE_HEADER';
export const MessageHeaderDiscriminantKey = '@type';
export const MessagePositionDescriptorTypename = 'com.hubspot.cv.pubsub.core.message.common.MessagePositionDescriptor';
export const MessagePositionDescriptorDiscriminant = 'MESSAGE_POSITION_DESCRIPTOR';
export const MessagePositionDescriptorDiscriminantKey = '@type';
export const QuickLinksTypename = 'com.hubspot.cv.pubsub.core.message.common.QuickLinks';
export const QuickLinksDiscriminant = 'QUICK_LINKS';
export const QuickLinksDiscriminantKey = '@type';
export const QuickRepliesTypename = 'com.hubspot.cv.pubsub.core.message.common.QuickReplies';
export const QuickRepliesDiscriminant = 'QUICK_REPLIES';
export const QuickRepliesDiscriminantKey = '@type';
export const RichMediaTemplatesTypename = 'com.hubspot.cv.pubsub.core.message.common.RichMediaTemplates';
export const RichMediaTemplatesDiscriminant = 'RICH_MEDIA_TEMPLATES';
export const RichMediaTemplatesDiscriminantKey = '@type';
export const SenderDiscriminantKey = '@type';
export const SocialMetadataAttachmentTypename = 'com.hubspot.cv.pubsub.core.message.common.SocialMetadataAttachment';
export const SocialMetadataAttachmentDiscriminant = 'SOCIAL_MEDIA_METADATA';
export const SocialMetadataAttachmentDiscriminantKey = '@type';
export const SystemSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.SystemSender';
export const SystemSenderDiscriminant = 'SYSTEM_SENDER';
export const SystemSenderDiscriminantKey = '@type';
export const UnsupportedContentAttachmentTypename = 'com.hubspot.cv.pubsub.core.message.common.UnsupportedContentAttachment';
export const UnsupportedContentAttachmentDiscriminant = 'UNSUPPORTED_CONTENT';
export const UnsupportedContentAttachmentDiscriminantKey = '@type';
export const VidSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.VidSender';
export const VidSenderDiscriminant = 'VID_SENDER';
export const VidSenderDiscriminantKey = '@type';
export const VisitorSenderTypename = 'com.hubspot.cv.pubsub.core.message.common.VisitorSender';
export const VisitorSenderDiscriminant = 'VISITOR_SENDER';
export const VisitorSenderDiscriminantKey = '@type';
export const WhatsAppTemplateMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.WhatsAppTemplateMetadata';
export const WhatsAppTemplateMetadataDiscriminant = 'WHATSAPP_TEMPLATE_METADATA';
export const WhatsAppTemplateMetadataDiscriminantKey = '@type';
export let ComHubspotCvPubsubCoreMessageCommon;
(function (_ComHubspotCvPubsubCoreMessageCommon) {
  const AttachmentDiscriminantKey = _ComHubspotCvPubsubCoreMessageCommon.AttachmentDiscriminantKey = '@type';
})(ComHubspotCvPubsubCoreMessageCommon || (ComHubspotCvPubsubCoreMessageCommon = {}));
export const AssociationUpdateTypename = 'com.hubspot.cv.pubsub.core.message.crmlifecycle.AssociationUpdate';
export const AssociationUpdateDiscriminant = 'ASSOCIATION_UPDATED';
export const AssociationUpdateDiscriminantKey = '@type';
export const CreatedUpdateTypename = 'com.hubspot.cv.pubsub.core.message.crmlifecycle.CreatedUpdate';
export const CreatedUpdateDiscriminant = 'CREATED';
export const CreatedUpdateDiscriminantKey = '@type';
export const CrmObjectLifecycleUpdateTypename = 'com.hubspot.cv.pubsub.core.message.crmlifecycle.CrmObjectLifecycleUpdate';
export const CrmObjectLifecycleUpdateDiscriminant = 'CRM_OBJECT_LIFECYCLE_UPDATE';
export const CrmObjectLifecycleUpdateDiscriminantKey = '@type';
export const CrmObjectUpdateDiscriminantKey = '@type';
export const PipelineStageUpdateTypename = 'com.hubspot.cv.pubsub.core.message.crmlifecycle.PipelineStageUpdate';
export const PipelineStageUpdateDiscriminant = 'PIPELINE_STAGE_UPDATED';
export const PipelineStageUpdateDiscriminantKey = '@type';
export const EngagementDetailsMessageTypename = 'com.hubspot.cv.pubsub.core.message.engagement.types.EngagementDetailsMessage';
export const EngagementDetailsMessageDiscriminant = 'ENGAGEMENT_DETAILS_MESSAGE';
export const EngagementDetailsMessageDiscriminantKey = '@type';
export const InitialMessageTypename = 'com.hubspot.cv.pubsub.core.message.v2.InitialMessage';
export const InitialMessageDiscriminant = 'INITIAL_MESSAGE';
export const InitialMessageDiscriminantKey = '@type';
export let ComHubspotEngagementsBaseEngagementsProtos;
(function (_ComHubspotEngagementsBaseEngagementsProtos) {})(ComHubspotEngagementsBaseEngagementsProtos || (ComHubspotEngagementsBaseEngagementsProtos = {}));
export const ConsentErrorTypename = 'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const NotificationErrorTypename = 'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorTypename = 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorTypename = 'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorTypename = 'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const TranslationsErrorTypename = 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const getRelevantThreadsForUserRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.ThreadViewRpc',
  rpcName: 'getRelevantThreadsForUser',
  auth: 'external',
  fingerprint: '3BmNBr6vY722LGlVcRB23IBUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThreadViewRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.ThreadViewRpc',
  rpcName: 'getThreadView',
  auth: 'external',
  fingerprint: 'vXM84PDiRKSXhjes9utBx4BUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};